import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import StringConstants from 'app/shared/constants/StringConstants';

// styles
import './style.scss';

const BlockedUserModal = ({ brand }) => {
    const isZillow = () => brand === StringConstants.UNFORMATTED_BRAND_NAMES.zillow;

    const email = isZillow() ?
        'account_verification@zillow.com' :
        'account_verification@hotpads.com';

    const actionBrand = isZillow ?
        StringConstants.FORMATTED_BRAND_NAMES.zillow :
        StringConstants.FORMATTED_BRAND_NAMES.hotpads;

    const actionContent = (
        <div>
            Return to&nbsp;
            <Link to={`https://www.${actionBrand.toLowerCase()}.com`}>{actionBrand}</Link>
        </div>
    );

    const header = 'Your account is currently disabled';
    const body = (
        <React.Fragment>
            <div>We are unable to access your properties at this time.</div>
            <div>
                Please contact&nbsp;
                <Link href={`mailto:${email}`} escape={true}>{email}</Link>
                &nbsp;to resolve the issue.
            </div>
        </React.Fragment>
    );

    return (
        <div className="BlockedUserModalContent">
            <Text className="BlockedUserModalContent-Header" type="h3">{header}</Text>
            <Text className="BlockedUserModalContent-Body" type="body">{body}</Text>
            <Text className="BlockedUserModalContent-Action" type="body">{actionContent}</Text>
        </div>
    );
};

BlockedUserModal.propTypes = {
    brand: PropTypes.oneOf(Object.values(StringConstants.UNFORMATTED_BRAND_NAMES)).isRequired,
};

export default BlockedUserModal;
